import { BaseEndpoint } from './Base';
export class AuthEndpoint extends BaseEndpoint {
    async getHeaders(headers) {
        const EP = this.constructor;
        if (!EP.accessToken) {
            return super.getHeaders(headers);
        }
        return {
            ...(await super.getHeaders(headers)),
            Authorization: EP.accessToken ? `Bearer ${EP.accessToken}` : ''
        };
    }
}
